import { Fragment, useMemo } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Divider from 'LuxKit/Divider'
import Group from 'components/utils/Group'
import ChatListSectionLabel from 'tripPlanner/pages/chat/ChatListSectionLabel'
import ChatLandingTryAskingRow from './ChatLandingTryAskingRow'

interface Props {
  disabled: boolean
  onSelectPrompt: (prompt: string) => void
}

function ChatLandingTryAsking({ disabled, onSelectPrompt }: Props) {
  const intl = useIntl()
  const prompts = useMemo(() => [
    intl.formatMessage({
      id: 'mOXwZz9znOraBctHPvQ3',
      defaultMessage: 'What are the best deals this week?',
      description: 'Example question a new traveller can send to the trip planner chat from its landing page',
    }),
    intl.formatMessage({
      id: 'LJApSSjKFmCRQvo69Kq5',
      defaultMessage: 'Find a beachfront resort in Bali with a kids club',
      description: 'Example family hotel request a new traveller can send to the trip planner chat from its landing page',
    }),
    intl.formatMessage({
      id: 'Qzpv2CO3MiK4lsUs6k5C',
      defaultMessage: 'Plan 5 days in Tokyo for food lovers',
      description: 'Example itinerary request a new traveller can send to the trip planner chat from its landing page',
    }),
  ], [intl])

  return (
    <Group direction="vertical" gap={12} fullWidth>
      <ChatListSectionLabel>
        <FormattedMessage
          id="8yXbnd0PREN1EyOsOpUy"
          defaultMessage="Try asking"
          description="Label above example questions on the trip planner chat landing page for travellers with no chats yet"
        />
      </ChatListSectionLabel>
      <div>
        {prompts.map((prompt, index) => (
          <Fragment key={prompt}>
            {index > 0 && <Divider kind="primary" />}
            <ChatLandingTryAskingRow prompt={prompt} disabled={disabled} onSelect={onSelectPrompt} />
          </Fragment>
        ))}
      </div>
    </Group>
  )
}

export default ChatLandingTryAsking
